module.exports = __webpack_public_path__ + "media/images/icon_alert-0813e789.png";